import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamic-svg',
  templateUrl: 'dynamic-svg.component.svg',
  styleUrls: ['dynamic-svg.component.scss']
})
export class DynamicSVGComponent implements OnInit {
  
  constructor() { }

  ngOnInit() {
    this.changeColor();
  }

  public myFill = "rgb(255, 0, 0)";

  public changeColor() {
    const r = Math.random() * 256;
    const g = Math.random() * 256;
    const b = Math.random() * 256;
    this.myFill = `rgb(${r}, ${g}, ${b})`;
  }
}
